<!-- Migrated from legacy/Plus/Plus/2017/Events/index.shtml ("2013 Events" section) -->

<template>
  <h3><span style="font-weight: 200">'Ten Commandments: Connect with Science'</span></h3>
  <h4>7pm, Thursday 30 May 2013 &mdash; Museum of Contemporary Art, Sydney</h4>
  <p class="subpages">
    <strong>More about this event:</strong>
    <router-link to="/2013/Showcase/Program">Program</router-link> &middot;
    <router-link to="/2013/Showcase/Lightning">Lightning Talks</router-link> &middot;
    <router-link to="/2013/Showcase/Stories">Stories</router-link> &middot;
    <router-link to="/2013/Showcase/Venue">Venue</router-link>
  </p>
  <p>
    Scientists and creative practitioners have more ways, and more reasons, to collaborate than
    ever before. This event explored how the tools of cinematography, storyboarding, graphic
    design, and sound engineering are increasingly being used to communicate modern, complex
    science &mdash; opening up a whole new arena for creatives with an interest in science, and
    for creative scientists alike.
  </p>
  <img class="banner" src="/Showcase/2013.jpg" alt="VIZBI Showcase 2013 hero image" />
  <p>
    The event featured live presentations from two world-leading biomedical animators and science
    communicators: Graham Johnson from UCSF (USA) and Drew Berry &mdash; winner of a MacArthur
    Fellowship, a BAFTA, and an Emmy award &mdash; from the Walter and Eliza Hall Institute in
    Melbourne. Following the talks, participants networked over a mixer in the adjacent MCA
    Lounge, where a limited number of participants whose work bridges science and creativity
    briefly introduced their work to the audience.
  </p>
  <img
    class="invite"
    src="/Showcase/2013/VIZBIplus-vividMay30.jpg"
    alt="Vivid Ideas: Connect With Science" />
  <p>
    This event was jointly presented by the
    <a href="https://www.vividsydney.com/">Vivid Ideas festival</a> and VizbiPlus: Visualising the
    Future of Biomedicine, a project funded by the Inspiring Australia government initiative, the
    <a href="https://www.garvan.org.au/">Garvan Institute of Medical Research</a>, the
    <a href="https://www.wehi.edu.au">Walter and Eliza Hall Institute for Medical Research
      (WEHI)</a>, and <a href="https://www.csiro.au/">CSIRO</a>.
  </p>
  <div class="gallery">
    <a href="/Showcase/2013/PollardGrahamPoster2.jpg" title="Graham Johnson: Cellular Components">
      <img
        src="/Showcase/2013/PollardGrahamPoster2_sm.png"
        alt="Illustration of Cellular Components" />
    </a>
    <a
      href="/Showcase/2013/GrahamFrankNeuronCoverFinal4brt.jpg"
      title="Graham Johnson: Illustration of Neuronal Fibers">
      <img
        src="/Showcase/2013/GrahamFrankNeuronCoverFinal4brt_sm.png"
        alt="Illustration of Neuronal Fibers" />
    </a>
    <a href="/Showcase/2013/DNA_methylation.jpg" title="Drew Berry: DNA methylation">
      <img src="/Showcase/2013/DNA_methylation_sm.png" alt="DNA methylation" />
    </a>
    <a
      href="/Showcase/2013/mRNA_transcription.jpg"
      title="Drew Berry: Messenger RNA (mRNA) is transcribed">
      <img
        src="/Showcase/2013/mRNA_transcription_sm.png"
        alt="Close-up View of mRNA transcription" />
    </a>
  </div>
  <h4>About Graham Johnson</h4>
  <img
    class="portrait right"
    src="/Showcase/2013/Connect-with-science-JohnsonG.jpg"
    alt="Portrait of Graham Johnson with his illustration of a synapse" />
  <p>
    <a href="https://www.grahamjlab.org/">Graham Johnson</a>, PhD is a Certified Medical
    Illustrator who has specialized in molecular and cellular biology since graduating from The
    Johns Hopkins School of Medicine in 1997. He illustrated both editions of the textbook Cell
    Biology by Pollard &amp; Earnshaw as a coauthor, and has created thousands of scientific
    visuals ranging from journal covers to pedagogic animations and game designs. Graham works at
    UCSF as a qb3@UCSF Faculty Fellow. His PhD work in the Molecular Graphics Lab at Scripps
    focused primarily on developing algorithms to enable scientists and illustrators to generate,
    simulate, and visualize molecular models of cells.
  </p>
  <h4>About Drew Berry</h4>
  <img
    class="portrait left"
    src="/Showcase/2013/drewBerry.jpg"
    alt="Portrait of Drew Berry in his studio at WEHI" />
  <p>
    <a href="https://www.wehi.tv/">Drew Berry</a> is a biologist-animator whose scientifically
    accurate and aesthetically rich visualisations reveal cellular and molecular processes for a
    wide range of audiences. Trained as a cell biologist and microscopist, Drew brings a rigorous
    scientific approach to each project, immersing himself in relevant research to ensure current
    data are represented. Since 1995, he has been a biomedical animator at the Walter and Eliza
    Hall Institute of Medical Research. His animations have been exhibited at venues such as the
    Guggenheim Museum, MoMA, the Royal Institute of Great Britain, and the University of Geneva.
    In 2010 he received a MacArthur Fellowship "Genius Award". See also his
    <a href="https://www.ted.com/talks/drew_berry_animations_of_unseeable_biology.html">TED
      talk</a>
    and the <a href="https://www.youtube.com/watch?v=Wa1A0pPc-ik">Bj&ouml;rk 'Hollow' music
      video</a>.
  </p>
</template>

<style scoped>
h3 {
  display: inline;
}
h4 {
  font-weight: 600;
  font-size: 1rem;
  margin-top: 1.5rem;
  clear: both;
}
p.subpages {
  font-size: 0.9rem;
}
img.banner {
  width: 100%;
  height: auto;
  border-radius: 4px;
  margin-bottom: 0.5rem;
}
img.invite {
  float: left;
  max-width: 40%;
  margin: 0 1.5rem 1rem 0;
  border-radius: 4px;
}
.gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  clear: both;
}
.gallery img {
  height: 140px;
  width: auto;
  border-radius: 4px;
}
img.portrait {
  max-width: 45%;
  border-radius: 4px;
}
img.portrait.right {
  float: right;
  margin: 0 0 1rem 1.5rem;
}
img.portrait.left {
  float: left;
  margin: 0 1.5rem 1rem 0;
}
</style>
